module.exports = __webpack_public_path__ + "static/apple-71a9f8c5affa2b249dc9865269b4ab2f.svg";